import * as lineOtpAuth from '@/services/apis/lineOtpAuth'

const state = {
  loginCredentials: {
    username: null,
    password: null
  }
}

const mutations = {
  SET_LOGIN_CREDENTIALS(state, { username, password }) {
    state.loginCredentials = { username, password }
  },
  CLEAR_LOGIN_CREDENTIALS(state) {
    state.loginCredentials = {
      username: null,
      password: null
    }
  }
}

const getters = {
  getLoginCredentials: state => state.loginCredentials
}

const actions = {
  async verifyLineOtp({ state, rootState }, { otp, reference }) {
    try {
      const { username, password } = state.loginCredentials;
      console.log('Store: verifyLineOtp called with:', {
        username,
        password,
        otp,
        reference
      });
  
      const response = await lineOtpAuth.loginWithOtp(
        username,
        password,
        otp,
        reference
      );
  
      if (response?.status === 201 && response?.data?.access_token) {
        return {
          data: response.data,
          status: response.status
        };
      } else {
        throw new Error(JSON.stringify({
          message: response?.data?.message || 'No access token received',
          status: response?.status,
          data: response?.data
        }));
      }
    } catch (err) {
      console.error('Store: verifyLineOtp error:', err);
      throw err;
    }
  },

  async setAdminLineOtpStatus({ }, data) {
    try {
      return await lineOtpAuth.setAdminLineOtpStatus(data)
    } catch (err) {
      console.error('Set Admin Line OTP Status Error:', err);
      throw err
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}